import React, { useState, useEffect, useRef } from "react";
import { Form, Spinner } from 'react-bootstrap';
import InputGroup from "react-bootstrap/InputGroup";

const TextArea = ({
    labelName,
    placeholder,
    rows = '5',
    value,
    onChange,
    errorOccured,
    errorMessage,
    onBlur,
    onFocus,
    disabled,
    name,
    maxLength = 500,
    type,
    autoActivated,
}) => {
    const [activated, setActivated] = useState(false);
    const labelRef = useRef(null);
    const [coverWidth, setCoverWidth] = useState(0);
    const [isListening, setIsListening] = useState(false);
    let recognition;
    let silenceTimeout;

    useEffect(() => {
        setCoverWidth(labelRef.current ? (labelRef.current.getBoundingClientRect().width + 9) : 0);
        if (value?.length > 0) {
            setActivated(true);
        } else {
            if (autoActivated) {
                setActivated(true);
            } else {
                setActivated(false);
            }
        }
    }, [labelRef, value, autoActivated]);

    function onBlurCheckInput() {
        onBlur();
        if (value.length > 0) {
            setActivated(true);
        } else {
            if (autoActivated) {
                setActivated(true);
            } else {
                setActivated(false);
            }
        }
    }

    const onBlurFn = () => {
        if (value.length > 0) {
            onBlurCheckInput();
        } else {
            if (autoActivated) {
                setActivated(true);
            } else {
                setActivated(false);
            }
        }
    };

    const startListening = () => {
        if (!("webkitSpeechRecognition" in window || "SpeechRecognition" in window)) {
            alert("Your browser does not support Speech Recognition. Try Chrome.");
            return;
        }

        recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = (event) => {
            let transcript = "";
            for (let i = event.resultIndex; i < event.results.length; i++) {
                transcript += event.results[i][0].transcript;
            }
            onChange({ target: { name, value: transcript } });
            resetSilenceTimer();
        };

        recognition.onerror = (event) => {
            console.error("Speech Recognition Error:", event.error);
        };

        recognition.onend = () => {
            setIsListening(false);
        };

        recognition.start();
        setIsListening(true);
        resetSilenceTimer();
    };

    const stopListening = () => {
        if (recognition) {
            recognition.stop();
        }
        clearTimeout(silenceTimeout);
        setIsListening(false);
    };

    const resetSilenceTimer = () => {
        clearTimeout(silenceTimeout);
        silenceTimeout = setTimeout(() => {
            stopListening();
        }, 5000);
    };

    return (
        <>
            <div className={errorOccured ? "" : "mb-3"} style={{ width: '100%', position: 'relative' }}>
                <InputGroup onFocus={() => { setActivated(true) }}>
                    <Form.Control
                        className={`${errorOccured && 'border-danger'} rounded py-2`}
                        type={type}
                        as="textarea"
                        onChange={onChange}
                        value={value}
                        onBlur={onBlurFn}
                        disabled={disabled}
                        onFocus={onFocus}
                        name={name}
                        maxLength={maxLength}
                        rows={rows}
                        style={{
                            height: 'auto',
                            resize: "none",
                            zIndex: activated ? "" : 4,
                            background: activated ? "" : "transparent",
                            paddingRight: '2.5rem'
                        }}
                    />
                    <label
                        className={`${activated ? "textfield-label-activated" : "textfield-label-unactivated"} textfield-label ${errorOccured && 'text-danger'}`}
                        ref={labelRef}
                        style={{ zIndex: '4' }}
                        onClick={() => { setActivated(true) }}
                    >
                        <strong>{labelName}</strong>
                    </label>
                    <div
                        className={`${activated ? "textfield-label-cover-activated" : "textfield-label-cover-unactivated"} textfield-label-cover`}
                        style={{ width: coverWidth, zIndex: '3' }}
                    />
                </InputGroup>



                <i
                    className={`fa fs-3 ${isListening ? "fa-stop-circle text-danger" : "fa-microphone "}`}
                    onClick={isListening ? stopListening : startListening}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '25px',
                        transform: 'translateY(-50%)',
                        zIndex: 5,
                        cursor: 'pointer'
                    }}
                />

                {isListening &&
                    <Spinner
                        variant="danger" size="" animation="grow"
                        className={``}
                        style={{
                            position: 'absolute',
                            right: '6px',
                            top: '10px',
                            // transform: 'translateY(-50%)',
                            zIndex: 4,
                            cursor: 'pointer'
                        }}
                    />
                }

            </div>
            {errorOccured && (
                <div className={`${errorOccured ? "mb-3" : ""} text-danger fs-12`} style={{ height: errorMessage === "" ? "16px" : "" }}>
                    {errorMessage}
                </div>
            )}
        </>
    );
};

export default TextArea;
